<template>
  <div class="paiwei robot-content">
    <Header></Header>
    <div class="paiwei-content">
        <div class="otp-title ac">{{$t('game1T')}}</div>
          <div class="otp-modal paiwei-bg ac">
            <div class="disflex" style="height: 280px;">
              <div class="avatar-content disflex" style="justify-content: space-evenly;">
                <div class="avatar1">
                  <img class="avatar-img-150"  :src="info.avatar">
                  <!-- <div class="name">user name</div> -->
                </div>
                <div class="vs"><img width="100" src="../../static/images/vs.png"></div>
                <div class="avatar2">
                  <img width="150" src="../../static/images/rob-avatar.png">
                  <!-- <div class="name">user name</div> -->
                </div>
              </div>
            </div>
           <div class="paiwei-c">
             <div class="span cr755dfa fs33 fw7" style="margin:50px 0 20px;">{{$t('game1Tips1')}}</div>
             <div class="paiwei-list">
                <div class="paiwei-li bge3ffce" @click="getRobot3('Easy')">{{$t('Easy')}}</div>
                <div class="paiwei-li bgcee5ff" @click="getRobot3('Medium')">{{$t('Medium')}}</div>
                <div class="paiwei-li bgffcece" @click="getRobot3('Hard')">{{$t('Hard')}}</div>
             </div>
           </div>
          </div>
      </div>

    <!-- 购买机会 -->
    <Dialog ref="otpDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
      <div class="" slot="mdBox">
        <div class="otp-title" >{{$t('ChanceEnough')}}</div>
        <div class="otp-modal ac">
          <img style="margin: -40px auto;" src="../../static/images/buy-img.png">
          <div class="otp-font">
            {{$t('BuyChancesC')}}
          </div>
          <div class="mt10 disflex">
            <button class="btn btn-none" style="border: 2px solid #fff;color:#fff;width: auto;min-width: 250px;" @click="cancelOtpDialog">{{$t('Later')}}</button>
            <button class="btn btn-blue" style="width: auto;min-width: 250px;" @click="getSubmit">{{$t('BuyMore')}}</button>
          </div>
        </div>
      </div>
    </Dialog>

  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
  data() {
    return {
      otp:'',
      codeText:'',
      score:'',
      info:{},
      backgroundAudio: null
    }
  },
  created() {
    this.getUserInfo();

  },
  beforeDestroy() {

  },
  methods: {
    getRobot3(type){
      this.$router.push({path:'/robot',query: {type:type}});
    },
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.info = r.data
          if (r.data.score < 1 ){
            that.$refs.otpDialog.showMaskFun();
          }
        });
      })
    },
    cancelOtpDialog(){
      this.$refs.otpDialog.closeMask();
      this.$router.push({path:'/'});
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.$refs.otpDialog.closeMask();
            that.$utils.alertText(r.msg,80, 800);
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/waitRobot.vue